export type ContactTooltipData = {
  name?: string
  internalNumber?: string
  mobilePhone?: string | null
}

export const hasContactTooltipData = (contact: ContactTooltipData | null | undefined): contact is ContactTooltipData => {
  return Boolean(contact?.name || contact?.internalNumber)
}
